<template>
  <div class="research_group_container" v-if="researchGroupCharacter === 'leader' || researchGroupCharacter === 'approver'">
    <div class="hd research-background-color">
      <span class="icon icon-left navshare" @click="goBack" v-if="!isWapp"></span>
      <span class="header_title">审批订单详情</span>
    </div>
    <div class="box" v-if="hasDisplayData">
     <div class="mouthNumber">月度累积已消费金额：¥{{splitMoney(orderDetail.monthlyTotalApprovedAmount)}}</div>
      <div class="bd">
        <span class="orderNumber" style="margin-top: 0;color: #424242;">订单信息</span>
        <span class="orderNumber">下单成员：{{orderDetail.orderPerson}}</span>
        <span class="orderNumber">下单时间：{{orderDetail.orderTime}}</span>
        <span class="orderNumber">订单编号：{{orderDetail.orderNo}}</span>
        <span class="price">订单总金额：¥{{splitMoney(orderDetail.price)}}</span>
      </div>

      <div class="bd">
        <span class="orderNumber" style="margin-top: 0;color: #424242;">产品列表</span>
        <div class="outer_3" v-for="(item, index) in orderDetail.itemList" :key="index">
          <div class="moneyWrap">
            <span class="info_3" v-if="item.TLNo">{{item.name}} {{item.promoter3ID}} {{item.tag1PUBID}} {{item.eu_RID}}</span>
            <span class="info_3" v-else>{{item.name}}</span>

            <div class="outer" v-if="item.tax">
              <span class="color_4"><span class="section">{{item.tax}}</span></span>
              <span class="color_4"><span class="section">{{item.symbol || item.microName}}</span></span>
              <span class="color_4"><span class="section">{{item.nm_ID || item.microNo}}</span></span>
            </div>
            <div class="periodWrap">
              <div class="sectionWrap research-background-color">
                <span class="section">周期：{{item.workdays}}个工作日</span>
              </div>
              <span class="money research-font-color">¥{{splitMoney(item.price)}}</span>
            </div>
          </div>
          <div class="block"><div class="empty" /></div>
        </div>
      </div>
      <div class="ft" >
        <div class="col1" @click="toggleResearchGroupDisagreeBox()" v-if="orderDetail.fromEmkt"><span class="tag">不同意</span></div>
        <div class="col2 research-background-color" @click="agree()" v-if="orderDetail.fromEmkt"><span class="tag_2">同意</span></div>
      </div>
      <div style="height: 10vw; visibility: hidden;">hidden</div>
    </div>
    <ResearchGroupDisagreeBox v-if="showResearchGroupDisagreeBox" @toggleShow="toggleResearchGroupDisagreeBox" @confirm="disagree"/>
  </div>
</template>
<script>
import {mapGetters, mapMutations} from 'vuex'
import $ from 'jquery'
import ResearchGroupDisagreeBox from './../researchGroupComponents/ResearchGroupDisagreeBox'
import EMKT from '../../../../emkt'
export default {
  data () {
    return {
      orderNo: this.$route.query.orderNo || EMKT.getFullUrlParam('orderNo'),
      reason: '',
      orderDetail: {},
      showResearchGroupDisagreeBox: false,
      researchGroupNo: this.$route.query.researchGroupNo || EMKT.getFullUrlParam('researchGroupNo')
    }
  },
  watch: {
    'researchGroupDetailList': {
      handler: 'setResearchGroupByGroupNo',
      immediate: true,
      isWapp: EMKT.isWapp
    }
  },
  computed: {
    ...mapGetters([
      'hasLogin', 'displayChosenResearchGroup', 'researchGroupCharacter', 'researchGroupDetailList', 'isWapp'
    ]),
    hasDisplayData () {
      if (!this.orderDetail || JSON.stringify(this.orderDetail) === '{}') {
        return false
      } else {
        return true
      }
    }
  },
  components: {
    ResearchGroupDisagreeBox
  },
  methods: {
    ...mapMutations([
      'UPDATE_CHOSEN_RESEARCH_INDEX'
    ]),
    setResearchGroupByGroupNo () {
      if (!this.hasLogin) {
        $.toast('请登录')
        this.$router.push({name: 'login'})
      }
      if (!this.researchGroupNo) return
      let researchGroupIndex = 0
      for (let i = 0; i < this.researchGroupDetailList.length; i++) {
        if (this.researchGroupDetailList[i].researchGroupNo === this.researchGroupNo) {
          researchGroupIndex = i
          continue
        }
      }
      this.UPDATE_CHOSEN_RESEARCH_INDEX(researchGroupIndex)
      if (this.researchGroupCharacter === 'leader' || this.researchGroupCharacter === 'approver') {
        this.fetchWaitApproveOrderDetail()
      }
    },
    goBack () {
      this.$router.push({name: 'ApproveOrder', query: {researchGroupNo: this.researchGroupNo}})
    },
    splitMoney (moneyNumber) {
      if (moneyNumber === undefined) {
        return ''
      }
      return String(moneyNumber).replace(/\B(?=(?:\d{3})+\b)/g, ',')
    },
    fetchWaitApproveOrderDetail () {
      if (this.researchGroupNo && this.orderNo) {
        this.$weui.loading('查询中')
        this.gcapi('loadWaitingApprovedOrderList', this.researchGroupNo).then(res => {
          if (res && res.body.result) {
            const waitApproveOrderList = res.body.result
            const specificWaitApproveOrderList = waitApproveOrderList.filter(order => order.orderNo === this.orderNo)
            if (specificWaitApproveOrderList.length === 0) {
              this.$weui.loading().hide()
              this.orderDetail = {}
              return this.$weui.toast('此订单已完成审批')
            } else {
              this.gcapi('loadWaitingApprovedOrderDetail', this.orderDetail.id).then(res => {
                this.$weui.loading().hide()
                if (res && res.body.result) {
                  this.orderDetail = res.body.result
                }
              })
            }
          }
        })
      }
    },
    agree () {
      const approveParams = {
        orderNo: this.orderNo,
        orderId: this.orderDetail.id,
        isApproved: true
      }
      this.$weui.loading('保存中')
      this.gcapi('approveResearchGroupOrder', approveParams).then(res => {
        this.$weui.loading().hide()
        if (res && res.body.code === 0) {
          this.goBack()
        } else {
          $.toast('保存失败')
        }
      })
    },
    disagree (reason) {
      console.log('reason', reason)
      if (!reason) return $.toast('请填写原因')
      const approveParams = {
        orderNo: this.orderNo,
        orderId: this.orderDetail.id,
        isApproved: false,
        remark: reason
      }
      this.$weui.loading('保存中')
      this.gcapi('approveResearchGroupOrder', approveParams).then(res => {
        this.$weui.loading().hide()
        if (res && res.body.code === 0) {
          this.goBack()
        } else {
          this.$weui.toast('保存失败')
        }
      })
    },
    toggleResearchGroupDisagreeBox () {
      this.showResearchGroupDisagreeBox = !this.showResearchGroupDisagreeBox
    }
  }
}
</script>
<style scoped>
.research_group_container {
  overflow-y:auto;
  overflow-x:hidden;
  height:100%;
}
.box {
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: column;
  background-color: #efeef3;
  width: 100vw;
  height: 100vh;
  top: 14.93vw;
}

.hd {
  display: flex;
  position: fixed;
  top:0;
  left:0;
  align-items: center;
  flex-direction: row;
  /*background-color: #5878fa;*/
  width: 100vw;
  height: 14.93vw;
  z-index: 10;
  justify-content: center;
}


.navshare {
  position: absolute;
  left: 6.67vw;
  width: 10vw;
  height: 10vw;
  padding-top: 2vw;
  color:#ffffff;
}
.header_title {
  opacity: 1;
  /*margin-left: 29.33vw;*/
  max-width: 60.53vw;
  height: 5.87vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 5.87vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 4.27vw;
  font-weight: 400;
}

.outer_3 {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  background-color: #ffffff;
  width: 86.67vw;
  flex-shrink: 0;
  /* padding: 2vw 0; */
}

.bd {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin-top: 6.67vw;
  border-radius: 2.67vw;
  background-color: #ffffff;
  width: 86.67vw;
  flex-shrink: 0;
  /* height: 37.33vw; */
  padding: 5vw 0;
}

.orderNumber {
  opacity: 1;
  margin-top: 3vw;
  margin-left: 6.67vw;
  max-width: 76.8vw;
  /* height: 4.53vw; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #929292;
    line-height: 5.33vw;
  font-size: 3.73vw;
  font-weight: 400;
}

.price {
  opacity: 1;
  margin-top: 3.2vw;
  margin-right: 6.4vw;
  /* height: 4.53vw; */
  white-space: nowrap;
  color: #ff9400;
  line-height: 1rem;
  font-size: .7rem;
  font-weight: 400;
  align-self: flex-end;
}
.periodWrap {
  display: flex;
  position: relative;
  align-items: center;
  align-self: center;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 1.07vw;
  width: 73.33vw;
  height: 5.6vw;
}
.moneyWrap {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  /*margin-top: 3.47vw;*/
  padding-right: 6.4vw;
  padding-left: 6.67vw;
  width: 86.67vw;
}

.sectionWrap {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  /*margin-top: 0.53vw;*/
  border-radius: 1.87vw;
  padding: 0 1vw;
  /*background-color: #5878fa;*/
  /* width: 26.67vw; */
  /*height: 3.73vw;*/
}

.section {
  opacity: 1;
  /* max-width: 26vw; */
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  /* line-height: 3.73vw; */
  white-space: nowrap;
  color: #ffffff;
  font-size: 3.2vw;
  font-weight: 400;
  /*transform: scale(0.8);*/
}

.money {
  opacity: 1;
  margin-top: 2.67vw;
  /* width: 10.67vw; */
  height: 4.53vw;
  text-align: right;
  line-height: 4.53vw;
  white-space: nowrap;
  /*color: #5878fa;*/
  font-size: 3.2vw;
  font-weight: 400;
}
.block {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 2.13vw;
  width: 86.4vw;
}

.empty {
  border-top-width: 0.7px;
  border-top-style: solid;
  border-top-color: rgba(213, 213, 213, 1);
  width: 73.6vw;
  height: 0.53vw;
}
.outer_3:last-child .empty{
  width: 73.6vw;
  height: 0.53vw;
  border: 0;
}

.ft {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 6.67vw;
  padding-right: 6.4vw;
  padding-left: 6.67vw;
  flex-shrink: 0;
  width: 100vw;
}

.col1 {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  border-radius: 2.67vw;
  background-color: #fe654d;
  width: 40vw;
  height: 13.33vw;
}

.tag {
  opacity: 1;
  max-width: 36.8vw;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 3.73vw;
  font-weight: 400;
}

.col2 {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  border-radius: 2.67vw;
  /*background-color: #5878fa;*/
  width: 40vw;
  height: 13.33vw;
}

.tag_2 {
  opacity: 1;
  max-width: 36.8vw;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 3.73vw;
  font-weight: 400;
}


.info_3 {
  /*position: relative;*/
  opacity: 1;
  margin-top: 2.4vw;
  /*margin-left: 6.67vw;*/
  max-width: 100%;
  height: 5.33vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #929292;
  font-size: 3.2vw;
  font-weight: 400;
}

.outer {
  display: flex;
  /*position: relative;*/
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
  /*margin-top: 0.53vw;*/
  /*margin-left: 8.53vw;*/
  width: 100%;
  height: 5.33vw;
}

.color_4 {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  /*margin-top: 0.53vw;*/
  border-radius: 1.87vw;
  margin-right: 2vw;
  /*height: 3.73vw;*/
  background-color: #ff9400;
  padding: 0 1vw;
}
.mouthNumber{
  font-size: 3.73vw;
  font-weight: 400;
  color: #ff9400;
  /* float: left; */
  /* text-align: left; */
  /* margin-bottom: -1rem; */
  padding-bottom: -5vw;
  margin-bottom: -5vw;
  margin-top: 5vw;
  margin-left: -30vw;
}
</style>



// WEBPACK FOOTER //
// ApproveOrderDetail.vue?7134c6d3